const POS = [-1, 0, 1];
const FACES = ["f", "b", "r", "l", "t", "d"];

function Cubie({ x, y, z, i }) {
  return (
    <div className="rk-cubie" style={{ "--x": x, "--y": y, "--z": z }}>
      {FACES.map((f, k) => (
        <div key={f} className={`rk-face rk-${f}`}>
          {(i * 7 + k * 3) % 5 === 0 && <span className="rk-glint" style={{ animationDelay: `${((i * 13 + k * 5) % 40) / 10}s` }} />}
        </div>
      ))}
    </div>
  );
}

export const RubikCube = ({ className = "" }) => {
  let i = 0;
  return (
    <div className={`rk-stage ${className}`} data-testid="rubik-cube-logo" aria-label="ECOREXS animated cube">
      <div className="rk-glow" />
      {[0, 1, 2, 3, 4, 5].map((p) => <span key={p} className="rk-particle" style={{ "--p": p }} />)}
      <div className="rk-cube">
        {POS.map((y, li) => (
          <div key={y} className={`rk-layer rk-layer-${li}`}>
            {POS.map((x) => POS.map((z) => <Cubie key={`${x}${z}`} x={x} y={y} z={z} i={i++} />))}
          </div>
        ))}
      </div>
    </div>
  );
};
